import {
    createAsyncThunk
} from '@reduxjs/toolkit';
import axios from 'axios';
import {
    api
} from '../../helpers/api_helper';
import {
    API_ENDPOINTS
} from '../../constants/apiEndPoints';


export const getNotificationAll = createAsyncThunk('notifications/getAll', async ({
    limit = 101,
    page = 1
}, thunkAPI) => {
    try {
        const response = await api.get(API_ENDPOINTS.NOTIFICATION.GET, {
            limit,
            page
        });
        console.log('response', response)
        return response.data;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.response.data);
    }
});

export const getNotificationUnreadCount = createAsyncThunk('notifications/getUnreadCount', async (_, thunkAPI) => {
    try {
        const response = await api.get(API_ENDPOINTS.NOTIFICATION.UNREAD_COUNT);
        // api.get already returns response.data via axios interceptor
        return response;
    } catch (error) {
        return thunkAPI.rejectWithValue(error);
    }
});